(function () {
  'use strict';

  var SUGGEST = '/search/suggest.json';
  var CART_GET = '/cart.js';
  var CART_ADD = '/cart/add.js';
  var CART_CHANGE = '/cart/change.js';
  var CART_CLEAR = '/cart/clear.js';
  var DEBOUNCE_MS = 250;
  var QTY_DEBOUNCE_MS = 350;

  // ===== Helpers =====
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }
  function jsonFetch(url, init) {
    init = init || {};
    init.headers = Object.assign({ 'Accept': 'application/json' }, init.headers || {});
    if (init.body && typeof init.body !== 'string') {
      init.headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(init.body);
    }
    return fetch(url, init).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error('HTTP ' + r.status + ': ' + t.slice(0, 200)); });
      return r.json();
    });
  }

  function getCart() { return jsonFetch(CART_GET); }
  function addToCart(variantId, quantity) {
    return jsonFetch(CART_ADD, { method: 'POST', body: { id: variantId, quantity: quantity || 1 } });
  }
  function changeCart(line, quantity) {
    return jsonFetch(CART_CHANGE, { method: 'POST', body: { line: line, quantity: quantity } });
  }
  function clearCart() {
    return jsonFetch(CART_CLEAR, { method: 'POST' });
  }
  function fetchProduct(handle) {
    return jsonFetch('/products/' + encodeURIComponent(handle) + '.js');
  }
  function fetchSuggest(q, limit) {
    var url = SUGGEST
      + '?q=' + encodeURIComponent(q)
      + '&resources[type]=product'
      + '&resources[limit]=' + (limit || 8)
      + '&resources[options][unavailable_products]=last';
    return jsonFetch(url).then(function (data) {
      var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
      return products.map(function (p) {
        return {
          handle: String(p.handle || ''),
          title: String(p.title || ''),
          image: (p.featured_image && (p.featured_image.url || p.featured_image)) || (p.image || '')
        };
      }).filter(function (p) { return p.handle; });
    });
  }

  // ===== Header bubble (sync with cart for client-side updates) =====
  function refreshHeaderBubble(cart) {
    var iconBubble = document.querySelector('#cart-icon-bubble');
    if (!iconBubble) return;
    var bubble = iconBubble.querySelector('.cart-count-bubble');
    var n = (cart && cart.item_count) || 0;

    if (n === 0) {
      if (bubble) bubble.style.display = 'none';
      return;
    }

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true">' + n + '</span><span class="visually-hidden">' + n + ' items</span>';
      iconBubble.appendChild(bubble);
    } else {
      bubble.style.display = '';
      var span = bubble.querySelector('span[aria-hidden]');
      if (span) span.textContent = n < 100 ? String(n) : '99+';
      else bubble.innerHTML = '<span aria-hidden="true">' + (n < 100 ? n : '99+') + '</span><span class="visually-hidden">' + n + ' items</span>';
    }
  }

  function refreshHeaderBubbleFromCart() {
    return getCart().then(refreshHeaderBubble).catch(function () {});
  }

  // ===== Picker (contact form) =====
  function QuotePicker(root) {
    this.root = root;
    this.chipsEl = root.querySelector('[data-quote-chips]');
    this.searchEl = root.querySelector('[data-quote-search]');
    this.dropdownEl = root.querySelector('[data-quote-dropdown]');
    this.emptyEl = root.querySelector('[data-quote-empty]');
    this.emptyHintEl = root.querySelector('[data-quote-empty-hint]');
    this.itemNumberInput = root.querySelector('[data-quote-item-number-hidden]');
    this.breakdownInput = root.querySelector('[data-quote-breakdown-hidden]');
    this.errorEl = root.querySelector('[data-quote-error]');
    this.quantityHelpEl = document.querySelector('[data-quantity-help]');
    this.form = root.closest('form');

    this.results = [];
    this.activeIndex = -1;
    this.cart = { items: [], item_count: 0 };

    this.bindEvents();
    var self = this;
    this.applyUrlParams().then(function () { return self.refreshFromCart(); });
  }

  QuotePicker.prototype.bindEvents = function () {
    var self = this;
    var debouncedSearch = debounce(function () { self.runSearch(); }, DEBOUNCE_MS);
    var debouncedQty = debounce(function (key, qty) { self.updateQty(key, qty); }, QTY_DEBOUNCE_MS);

    this.searchEl.addEventListener('input', debouncedSearch);
    this.searchEl.addEventListener('focus', function () {
      if (self.results.length) self.dropdownEl.removeAttribute('hidden');
    });
    this.searchEl.addEventListener('blur', function () {
      setTimeout(function () { self.closeDropdown(); }, 150);
    });
    this.searchEl.addEventListener('keydown', function (e) { self.onKeydown(e); });

    this.dropdownEl.addEventListener('mousedown', function (e) {
      var li = e.target.closest('[data-suggest-item]');
      if (!li) return;
      e.preventDefault();
      var idx = parseInt(li.getAttribute('data-idx'), 10);
      if (!isNaN(idx)) self.selectResult(idx);
    });

    this.chipsEl.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-chip-remove]');
      if (rm) self.removeChip(rm.getAttribute('data-key'));
    });
    this.chipsEl.addEventListener('input', function (e) {
      var qty = e.target.closest('[data-chip-qty]');
      if (qty) {
        var v = qty.value.replace(/[^\d]/g, '');
        if (v !== qty.value) qty.value = v;
        debouncedQty(qty.getAttribute('data-key'), v);
      }
    });

    if (this.form) {
      this.form.addEventListener('submit', function (e) { self.onSubmit(e); });
    }
  };

  QuotePicker.prototype.runSearch = function () {
    var q = this.searchEl.value.trim();
    if (!q) { this.results = []; this.closeDropdown(); return; }
    var self = this;
    fetchSuggest(q, 8).then(function (rows) {
      self.results = rows;
      self.activeIndex = rows.length ? 0 : -1;
      self.renderDropdown();
    }).catch(function () {
      self.results = [];
      self.renderDropdown();
    });
  };

  QuotePicker.prototype.renderDropdown = function () {
    if (!this.results.length) {
      this.dropdownEl.innerHTML = '<li class="quote-suggest-empty" role="presentation">No products found.</li>';
      this.dropdownEl.removeAttribute('hidden');
      return;
    }
    var existingHandles = {};
    (this.cart.items || []).forEach(function (it) {
      if (it.handle) existingHandles[it.handle] = true;
    });
    var self = this;
    this.dropdownEl.innerHTML = this.results.map(function (p, i) {
      var already = existingHandles[p.handle];
      var imgHtml = p.image
        ? '<img src="' + escapeHtml(p.image) + '" alt="" loading="lazy" width="40" height="40">'
        : '<span class="quote-suggest-noimg" aria-hidden="true"></span>';
      return ''
        + '<li class="quote-suggest-item' + (already ? ' quote-suggest-item--disabled' : '') + (i === self.activeIndex ? ' quote-suggest-item--active' : '') + '"'
        + ' data-suggest-item data-idx="' + i + '" role="option" aria-selected="' + (i === self.activeIndex ? 'true' : 'false') + '">'
        + imgHtml
        + '<span class="quote-suggest-meta">'
        + '<span class="quote-suggest-title">' + escapeHtml(p.title) + '</span>'
        + '</span>'
        + (already ? '<span class="quote-suggest-tag">Added</span>' : '')
        + '</li>';
    }).join('');
    this.dropdownEl.removeAttribute('hidden');
  };

  QuotePicker.prototype.closeDropdown = function () {
    this.dropdownEl.setAttribute('hidden', '');
    this.activeIndex = -1;
  };

  QuotePicker.prototype.onKeydown = function (e) {
    if (this.dropdownEl.hasAttribute('hidden')) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      this.activeIndex = Math.min(this.activeIndex + 1, this.results.length - 1);
      this.renderDropdown();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      this.activeIndex = Math.max(this.activeIndex - 1, 0);
      this.renderDropdown();
    } else if (e.key === 'Enter') {
      if (this.activeIndex >= 0 && this.results[this.activeIndex]) {
        e.preventDefault();
        this.selectResult(this.activeIndex);
      }
    } else if (e.key === 'Escape') {
      this.closeDropdown();
    }
  };

  QuotePicker.prototype.selectResult = function (idx) {
    var p = this.results[idx];
    if (!p || !p.handle) return;
    var self = this;
    var existingHandles = {};
    (this.cart.items || []).forEach(function (it) {
      if (it.handle) existingHandles[it.handle] = true;
    });
    if (existingHandles[p.handle]) {
      this.searchEl.value = '';
      this.results = [];
      this.closeDropdown();
      this.searchEl.focus();
      return;
    }
    this.searchEl.value = '';
    this.results = [];
    this.closeDropdown();
    fetchProduct(p.handle).then(function (prod) {
      var variant = prod.variants && prod.variants[0];
      if (!variant) throw new Error('no variant');
      return addToCart(variant.id, 1);
    }).then(function () {
      return self.refreshFromCart();
    }).then(function () {
      self.searchEl.focus();
      if (self.errorEl) self.errorEl.setAttribute('hidden', '');
    }).catch(function (err) {
      if (window.console) console.error('Quote add failed', err);
      if (self.errorEl) {
        self.errorEl.textContent = 'Could not add product. Please try again.';
        self.errorEl.removeAttribute('hidden');
      }
    });
  };

  QuotePicker.prototype.refreshFromCart = function () {
    var self = this;
    return getCart().then(function (cart) {
      self.cart = cart;
      self.renderChips(cart);
      refreshHeaderBubble(cart);
    }).catch(function () {});
  };

  QuotePicker.prototype.renderChips = function (cart) {
    var items = cart.items || [];
    if (!items.length) {
      this.chipsEl.setAttribute('hidden', '');
      this.chipsEl.innerHTML = '';
      if (this.emptyEl) this.emptyEl.removeAttribute('hidden');
      if (this.emptyHintEl) this.emptyHintEl.removeAttribute('hidden');
    } else {
      this.chipsEl.removeAttribute('hidden');
      if (this.emptyEl) this.emptyEl.setAttribute('hidden', '');
      if (this.emptyHintEl) this.emptyHintEl.setAttribute('hidden', '');
      this.chipsEl.innerHTML = items.map(function (it, idx) {
        var line = idx + 1;
        var sku = (it.sku || '').toUpperCase();
        var key = String(it.key || it.variant_id || line);
        var title = it.product_title || it.title || '';
        var skuHtml = sku
          ? '<span class="quote-chip-sku">' + escapeHtml(sku) + '</span>'
          : '';
        return ''
          + '<li class="quote-chip" data-chip-key="' + escapeHtml(key) + '" data-line="' + line + '">'
          + skuHtml
          + '<span class="quote-chip-title">' + escapeHtml(title) + '</span>'
          + '<button type="button" class="quote-chip-remove" data-chip-remove data-key="' + escapeHtml(key) + '" aria-label="Remove ' + escapeHtml(sku || title) + '">×</button>'
          + '</li>';
      }).join('');
    }
    this.syncHidden(cart);
    this.updateQuantityHelp(items.length);
  };

  QuotePicker.prototype.updateQuantityHelp = function (count) {
    if (!this.quantityHelpEl) return;
    if (count >= 2) {
      this.quantityHelpEl.innerHTML = 'Applied to each of your <strong>' + count + ' selected products</strong>. Need different counts per item? Note specifics in <em>Comments</em> below.';
    } else if (count === 1) {
      this.quantityHelpEl.innerHTML = 'How many of this item? For multiple price tiers, list them — e.g. <em>100, 250, 500</em>.';
    } else {
      this.quantityHelpEl.innerHTML = "How many you'd like priced. For multiple price tiers, list them — e.g. <em>100, 250, 500</em>.";
    }
  };

  QuotePicker.prototype.syncHidden = function (cart) {
    var items = cart.items || [];
    if (this.itemNumberInput) {
      this.itemNumberInput.value = items.map(function (it) {
        return (it.sku || '').toUpperCase();
      }).filter(Boolean).join(', ');
    }
    if (this.breakdownInput) {
      this.breakdownInput.value = items.map(function (it) {
        var sku = (it.sku || '').toUpperCase() || '(no SKU)';
        var title = it.product_title || it.title || '';
        return '  • ' + sku + '  — ' + title;
      }).join('\n');
    }
  };

  QuotePicker.prototype.removeChip = function (key) {
    var line = this.lineByKey(key);
    if (!line) return;
    var self = this;
    changeCart(line, 0).then(function (cart) {
      self.cart = cart;
      self.renderChips(cart);
      refreshHeaderBubble(cart);
    }).catch(function (err) { if (window.console) console.error('remove failed', err); });
  };

  QuotePicker.prototype.updateQty = function (key, qty) {
    var line = this.lineByKey(key);
    if (!line) return;
    var n = parseInt(qty, 10);
    if (isNaN(n) || n < 1) return;
    var self = this;
    changeCart(line, n).then(function (cart) {
      self.cart = cart;
      self.syncHidden(cart);
      refreshHeaderBubble(cart);
    }).catch(function (err) { if (window.console) console.error('qty update failed', err); });
  };

  QuotePicker.prototype.lineByKey = function (key) {
    var items = this.cart.items || [];
    for (var i = 0; i < items.length; i++) {
      var k = String(items[i].key || items[i].variant_id || (i + 1));
      if (k === String(key)) return i + 1;
    }
    return 0;
  };

  QuotePicker.prototype.applyUrlParams = function () {
    var params = new URLSearchParams(location.search);
    var rawItems = params.get('items') || '';
    if (!rawItems) return Promise.resolve();
    var skus = rawItems.split(',').map(function (s) { return s.trim().toUpperCase(); }).filter(Boolean);
    var qtys = (params.get('qty') || '').split(',').map(function (s) { return s.trim(); });
    if (!skus.length) return Promise.resolve();
    var tasks = skus.map(function (sku, i) {
      return fetchSuggest(sku, 4).then(function (rows) {
        if (!rows.length) return null;
        return fetchProduct(rows[0].handle).then(function (prod) {
          var variants = prod.variants || [];
          var variant = null;
          for (var j = 0; j < variants.length; j++) {
            if ((variants[j].sku || '').toUpperCase() === sku) { variant = variants[j]; break; }
          }
          if (!variant) variant = variants[0];
          if (!variant) return null;
          var qty = parseInt(qtys[i], 10);
          if (isNaN(qty) || qty < 1) qty = 1;
          return addToCart(variant.id, qty);
        });
      }).catch(function () { return null; });
    });
    return Promise.all(tasks).then(function () {});
  };

  QuotePicker.prototype.onSubmit = function (e) {
    var items = (this.cart && this.cart.items) || [];
    if (!items.length) {
      e.preventDefault();
      this.root.classList.add('is-invalid');
      if (this.errorEl) {
        this.errorEl.textContent = 'Please add at least one product to your quote. Use the search above, or click "Add to Cart" on any product page.';
        this.errorEl.removeAttribute('hidden');
      }
      this.searchEl.focus();
      this.searchEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
      var self = this;
      var clearInvalid = function () {
        self.root.classList.remove('is-invalid');
        if (self.errorEl) self.errorEl.setAttribute('hidden', '');
        self.searchEl.removeEventListener('input', clearInvalid);
      };
      this.searchEl.addEventListener('input', clearInvalid);
      return;
    }
    this.syncHidden(this.cart);
    try { sessionStorage.setItem('oxp_quote_pending_clear', '1'); } catch (e2) {}
  };

  function initContactPicker() {
    var root = document.querySelector('[data-quote-picker]');
    if (!root) return;
    new QuotePicker(root);
  }

  function maybeClearAfterSubmit() {
    try {
      if (!sessionStorage.getItem('oxp_quote_pending_clear')) return;
    } catch (e) { return; }
    var success = document.querySelector('[data-quote-success="1"]');
    if (success) {
      clearCart().then(function () {
        try { sessionStorage.removeItem('oxp_quote_pending_clear'); } catch (e2) {}
        refreshHeaderBubble({ item_count: 0 });
      }).catch(function () {});
    }
  }

  function initHeaderBubbleSync() {
    if (!document.querySelector('#cart-icon-bubble')) return;
    refreshHeaderBubbleFromCart();
  }

  // ===== Country selector (searchable phone country code) =====
  function CountrySelector(root) {
    this.root = root;
    this.trigger = root.querySelector('[data-country-trigger]');
    this.panel = root.querySelector('[data-country-panel]');
    this.search = root.querySelector('[data-country-search]');
    this.list = root.querySelector('[data-country-list]');
    this.empty = root.querySelector('[data-country-empty]');
    this.value = root.querySelector('[data-country-value]');
    this.flagEl = root.querySelector('[data-trigger-flag]');
    this.codeEl = root.querySelector('[data-trigger-code]');
    this.numberEl = root.querySelector('.oxp-phone__number');

    if (!this.trigger || !this.panel || !this.list) return;

    this.rows = Array.prototype.slice.call(this.list.querySelectorAll('.oxp-country-row'));
    this.activeIdx = -1;
    this.visibleRows = this.rows.slice();

    this.bindEvents();
  }

  CountrySelector.prototype.bindEvents = function () {
    var self = this;

    this.trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      self.toggle();
    });

    this.search.addEventListener('input', function () { self.filter(); });
    this.search.addEventListener('keydown', function (e) { self.onKeydown(e); });

    this.list.addEventListener('mousedown', function (e) {
      var row = e.target.closest('.oxp-country-row');
      if (!row || row.hidden) return;
      e.preventDefault();
      self.select(row);
    });

    this.list.addEventListener('mousemove', function (e) {
      var row = e.target.closest('.oxp-country-row');
      if (!row || row.hidden) return;
      var idx = self.visibleRows.indexOf(row);
      if (idx >= 0 && idx !== self.activeIdx) {
        self.setActive(idx);
      }
    });

    document.addEventListener('mousedown', function (e) {
      if (self.panel.hasAttribute('hidden')) return;
      if (self.root.contains(e.target)) return;
      self.close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !self.panel.hasAttribute('hidden')) {
        e.preventDefault();
        self.close();
        self.trigger.focus();
      }
    });
  };

  CountrySelector.prototype.toggle = function () {
    if (this.panel.hasAttribute('hidden')) this.open();
    else this.close();
  };

  CountrySelector.prototype.open = function () {
    this.panel.removeAttribute('hidden');
    this.trigger.setAttribute('aria-expanded', 'true');
    this.search.value = '';
    this.filter();
    var self = this;
    setTimeout(function () { self.search.focus(); }, 0);
  };

  CountrySelector.prototype.close = function () {
    this.panel.setAttribute('hidden', '');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.activeIdx = -1;
  };

  CountrySelector.prototype.filter = function () {
    var q = this.search.value.trim().toLowerCase();
    var qDigits = q.replace(/[^\d]/g, '');
    var hasQuery = q.length > 0;

    var bucketExactCode = [];
    var bucketCodePrefix = [];
    var bucketName = [];
    var bucketHidden = [];

    for (var i = 0; i < this.rows.length; i++) {
      var row = this.rows[i];
      var name = (row.getAttribute('data-name') || '').toLowerCase();
      var code = (row.getAttribute('data-code') || '');
      var codeDigits = code.replace('+', '');

      if (!hasQuery) {
        bucketName.push(row);
        continue;
      }

      var nameMatch = name.indexOf(q) !== -1;
      var codeExact = qDigits && codeDigits === qDigits;
      var codePrefix = qDigits && codeDigits.indexOf(qDigits) === 0;
      var queryHasCode = qDigits && qDigits.indexOf(codeDigits) === 0 && codeDigits.length > 0;

      if (codeExact) {
        bucketExactCode.push(row);
      } else if (codePrefix || queryHasCode) {
        bucketCodePrefix.push(row);
      } else if (nameMatch) {
        bucketName.push(row);
      } else {
        bucketHidden.push(row);
      }
    }

    var visible = bucketExactCode.concat(bucketCodePrefix, bucketName);

    // Re-order DOM so visible rows appear first in proper sort order
    var frag = document.createDocumentFragment();
    visible.forEach(function (r) { r.hidden = false; frag.appendChild(r); });
    bucketHidden.forEach(function (r) { r.hidden = true; frag.appendChild(r); });
    this.list.appendChild(frag);

    this.visibleRows = visible;
    if (this.empty) {
      if (visible.length === 0) this.empty.removeAttribute('hidden');
      else this.empty.setAttribute('hidden', '');
    }

    this.list.scrollTop = 0;
    this.setActive(visible.length > 0 ? 0 : -1);
  };

  CountrySelector.prototype.setActive = function (idx) {
    if (this.activeIdx >= 0 && this.visibleRows[this.activeIdx]) {
      this.visibleRows[this.activeIdx].classList.remove('is-active');
    }
    this.activeIdx = idx;
    if (idx >= 0 && this.visibleRows[idx]) {
      this.visibleRows[idx].classList.add('is-active');
      var row = this.visibleRows[idx];
      var rTop = row.offsetTop;
      var rBottom = rTop + row.offsetHeight;
      var sTop = this.list.scrollTop;
      var sBottom = sTop + this.list.clientHeight;
      if (rTop < sTop) this.list.scrollTop = rTop - 4;
      else if (rBottom > sBottom) this.list.scrollTop = rBottom - this.list.clientHeight + 4;
    }
  };

  CountrySelector.prototype.onKeydown = function (e) {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      this.setActive(Math.min(this.activeIdx + 1, this.visibleRows.length - 1));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      this.setActive(Math.max(this.activeIdx - 1, 0));
    } else if (e.key === 'Enter') {
      if (this.activeIdx >= 0 && this.visibleRows[this.activeIdx]) {
        e.preventDefault();
        this.select(this.visibleRows[this.activeIdx]);
      }
    } else if (e.key === 'Tab') {
      this.close();
    }
  };

  CountrySelector.prototype.select = function (row) {
    var flag = row.getAttribute('data-flag') || '';
    var code = row.getAttribute('data-code') || '';
    var value = row.getAttribute('data-value') || (flag + ' ' + code);

    if (this.flagEl) this.flagEl.textContent = flag;
    if (this.codeEl) this.codeEl.textContent = code;
    if (this.value) this.value.value = value;

    this.rows.forEach(function (r) {
      r.classList.remove('is-selected');
      r.setAttribute('aria-selected', 'false');
    });
    row.classList.add('is-selected');
    row.setAttribute('aria-selected', 'true');

    this.close();
    if (this.numberEl) {
      var self = this;
      setTimeout(function () { self.numberEl.focus(); }, 0);
    }
  };

  function initCountrySelectors() {
    var roots = document.querySelectorAll('[data-country-selector]');
    for (var i = 0; i < roots.length; i++) new CountrySelector(roots[i]);
  }

  function init() {
    initHeaderBubbleSync();
    initContactPicker();
    initCountrySelectors();
    maybeClearAfterSubmit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
